/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface PostThreadsAccountByUserUuidReqBodyDto
 */
export interface PostThreadsAccountByUserUuidReqBodyDto {
    /**
     * 계정 아이디
     * @type {string}
     * @memberof PostThreadsAccountByUserUuidReqBodyDto
     */
    'id': string;
    /**
     * 계정 비밀번호
     * @type {string}
     * @memberof PostThreadsAccountByUserUuidReqBodyDto
     */
    'password': string;
    /**
     * 2단계 인증 방법
     * @type {string}
     * @memberof PostThreadsAccountByUserUuidReqBodyDto
     */
    'twoFactorMethodType'?: PostThreadsAccountByUserUuidReqBodyDtoTwoFactorMethodTypeEnum;
    /**
     * 2단계 인증 코드
     * @type {string}
     * @memberof PostThreadsAccountByUserUuidReqBodyDto
     */
    'twoFactorCode'?: string;
}

export const PostThreadsAccountByUserUuidReqBodyDtoTwoFactorMethodTypeEnum = {
    Sms: 'sms',
    Otp: 'otp',
    Device: 'device'
} as const;

export type PostThreadsAccountByUserUuidReqBodyDtoTwoFactorMethodTypeEnum = typeof PostThreadsAccountByUserUuidReqBodyDtoTwoFactorMethodTypeEnum[keyof typeof PostThreadsAccountByUserUuidReqBodyDtoTwoFactorMethodTypeEnum];


